// 訓練期程大 modal（training-plan-inst-plan-inst-list「新增／修改訓練期程」＝
// legacy `#modalPlanInstDialog > #modalPlanInstForm`，modal-xxl）。
// 批次 15（B7-1，Gitea issue #13）。掛在 PageBehavior.editModal（批次 10 hook 先例，
// 未登錄頁零影響）；新增入口 showModalPlanInst(0,'add')（planInstList.jsp:40）、
// 修改入口＝主表學員欄 `a.showEdit`（planInstList_js.jsp:101-110/:122-127）。
//
// legacy 流程（行號以單檔 grep -n 重驗 2026-09-25，基準＝ePortfolio_work/ePortfolio-tsgh/
// WebContent/WEB-INF/views/training/planInst/；詳 docs/plans/2026-09-24-batch15-training-plan.md §1.1）：
//   - showModalPlanInst（planInstModalPlanInst.jsp:775-805）：id>0 → `getPlanInstAjax{id}`(:778)＋
//     btnDelete 顯示；add → planInst＝`#searchPlanInstForm` serializeObject＋id=0＋
//     studentCode=''＋btnDelete 隱藏。
//   - showModalPlanInstByAjax（:807-838）：title `新增訓練期程`(:814)/`修改訓練期程`(:819)
//     （thisFunctionName＝plan.inst＝訓練期程）；modify → `.noEdit` 全 disabled(:818-822/:850)
//     （學年度/醫院/訓練類別/訓練計畫/組別/學員不可改）。
//   - 主表單（:928-1009）：*學年度(:928-936)/*醫院(:939-946)/*訓練類別(job.type :949-954)/*訓練計畫
//     (plan.target :956-961)／組別(:962-967)／*學員（searchStudentCode `(請輸入學員姓名或學員編號)`
//     ＋studentId required :968-983）／計畫導師（searchMentorDept＋searchMentorNo
//     `(請輸入導師姓名或員工編號)`＋mentorId＋resetMentorIdBtn 清除 :984-1000）／
//     註記（hidden group :1001-1005）。
//   - :1007-1010 alert-danger `西醫UGY安排臨床教師時：臨床教師第1順位請指定住院醫師，第2順位請指定主治醫生`。
//   - 期程表 `#phaseInstListTable`（:1011-1022 表頭：*訓練期間/*訓練階段/階段導師/臨床教師
//     (clinical code＝臨床教師)/訓練地點/暫停訓練；欄渲染 :245-450）：col0 hidden
//     id/phaseType/phaseTargetIdName＋訓練期間 startDateStr/endDateStr 文字輸入（:116-136
//     renderStartDate/renderEndDate；endDate 格式空→整欄不顯示）；col1 訓練階段 select（leaf
//     :271-303：已配置→disabled 只剩自己；未配置→subPhaseTargetList；refId select :299 僅
//     選修1-5/社區/院內社區，preOption `請選擇`）；col2 階段導師（:329-351；mentorAmount>0→
//     mentorId1；>1→+BR mentorId2）；col3 臨床教師（:353-374；clinicalAmount>0/1/2→
//     clinicalId/clinicalId2/clinicalId3）；col4 訓練地點 wardId（:376-397；leaf 才有，
//     preOption `NA` :243）；col5 暫停訓練 isActive checkbox（:411-424；**isActive==0→checked**）。
//   - 非 leaf 列整列隱藏（hideNonLeafPhaseType :763-772）→ 雛形只渲染 leaf 列。
//   - 階段重覆（checkDuplicateSubPhase :666-682）：`訓練階段 [{text} ] 重覆,請重新選擇!`(:674)
//     ＋該 select 回 -1。
//   - 角色人員設定（:703-757）：`[角色人員設定]`(:717)（text-info）＋每列 roleName label＋
//     keyword input `(請輸入姓名或員工編號)`＋accountId select＋eraser；flowRole
//     Student/Mentor/Clinical/Any 對應帳號池。
//   - savePlanInst（:840-878）：valid（required inline）→ studentId<0 →
//     `showAlertDialog("學生資料錯誤!")`(:845) → .noEdit 解鎖 → `savePlanInstAjax`(:860) →
//     成功 hide＋`showInfoDialog(desc)`＋doQuery；失敗 alert(desc)。
//   - deletePlanInst（:880-901）：`sysConfirm('刪除資料後無法復原，是否確定要刪除?')`(:881)→
//     `deletePlanInstAjax{id}`。
//   - 關閉＝myCloseWindow（:902-904）只清 state，無關閉守衛。
//
// 雛形簡化（全部【雛形值待實機校準】，登記進度檔）：
//   - 級聯下拉→選項池平列（批次 11/12 先例）；日期→文字輸入（批次 11/13 先例）。
//   - focus 動態「未使用子階段」清單→靜態全列（legacy dynamicCreatePhaseTargetOption :543-570）。
//   - 導師/臨床教師的科部連動（changeSelectAcct :153-165）→科部 select 渲染但不過濾選項。
//   - 新增模式的期程骨架＝固定 2 列 leaf（legacy 由 getPhaseInstListAjax(:444) 依 planTarget 結構回）。
//   - 查詢表單帶值（planInst＝searchPlanInstForm serializeObject :786-805）→TRAINING_PLAN_INST_DEFAULTS。
//
// 【證據等級】§7 第 3 級（原始碼）。

import { useState, type ReactElement } from 'react';
import { Button } from '@/components/base/Button';
import { Checkbox } from '@/components/base/Checkbox';
import { Select } from '@/components/base/Select';
import { TextInput } from '@/components/base/TextInput';
import { ModalFrame, useDialogs } from '@/components/layouts';
import { t } from '@/messages/zh-TW';
import { MockDataError, resolveLegacyMessage, useDataSource } from '@/mocks';
import {
  ACCOUNT_ORGANIZATION_OPTIONS,
  COURSE_CLAZZ_ANNUAL_OPTIONS,
  COURSE_CLAZZ_PLAN_TARGET_OPTIONS,
  TRAINING_CLINICAL_OPTIONS,
  TRAINING_JOB_TYPE_OPTIONS,
  TRAINING_LEAF_PHASE_TYPES,
  TRAINING_MENTOR_DEPT_OPTIONS,
  TRAINING_MENTOR_OPTIONS,
  TRAINING_PHASE_TARGET_OPTIONS,
  TRAINING_PLAN_INST_DEFAULTS,
  TRAINING_REF_POOL,
  TRAINING_STUDENT_OPTIONS,
  TRAINING_SUB_PHASE_TARGETS,
  TRAINING_WARD_OPTIONS,
} from '@/mocks/resource-rules';
import type { Row } from '@/mocks/types';

export interface PlanInstEditModalProps {
  readonly pageId: string;
  /** 'create'＝新增（showModalPlanInst(0,'add')）；'edit'＝修改（學員連結 .showEdit）。 */
  readonly mode: 'create' | 'edit';
  /** 修改時的列（新增時 null）。 */
  readonly row: Row | null;
  /** CrudListPage 傳入的表單值（批次 12 B1-4 介面）。 */
  readonly values: Record<string, string>;
  readonly onClose: () => void;
  readonly onClosed: () => void;
}

/** 必填 inline（jquery.validate decorator.jsp:262）。 */
const REQUIRED_TEXT = '必填欄位';

interface PhaseRowState {
  id: string;
  phaseType: string;
  phaseTargetId: string;
  phaseTargetIdName: string;
  refId: string;
  startDateStr: string;
  endDateStr: string;
  mentorId1: string;
  mentorId2: string;
  clinicalId: string;
  clinicalId2: string;
  clinicalId3: string;
  wardId: string;
  isActive: string;
  mentorAmount: string;
  clinicalAmount: string;
}

/** legacy 期程列 → 可編輯 state（欄位照 planInstModalPlanInst.jsp 欄渲染 :284-455）。 */
function toPhaseStates(list: unknown): PhaseRowState[] {
  if (!Array.isArray(list)) {
    return [];
  }
  return list
    .filter((entry): entry is Record<string, unknown> => typeof entry === 'object' && entry !== null)
    .map((entry, index) => ({
      id: String(entry['id'] ?? `new-${index + 1}`),
      phaseType: String(entry['phaseType'] ?? 'SubPhase'),
      phaseTargetId: String(entry['phaseTargetId'] ?? '-1'),
      phaseTargetIdName: String(entry['phaseTargetIdName'] ?? ''),
      refId: String(entry['refId'] ?? ''),
      startDateStr: String(entry['startDateStr'] ?? ''),
      endDateStr: String(entry['endDateStr'] ?? ''),
      mentorId1: String(entry['mentorId1'] ?? ''),
      mentorId2: String(entry['mentorId2'] ?? ''),
      clinicalId: String(entry['clinicalId'] ?? ''),
      clinicalId2: String(entry['clinicalId2'] ?? ''),
      clinicalId3: String(entry['clinicalId3'] ?? ''),
      wardId: String(entry['wardId'] ?? ''),
      isActive: String(entry['isActive'] ?? '1'),
      mentorAmount: String(entry['mentorAmount'] ?? '0'),
      clinicalAmount: String(entry['clinicalAmount'] ?? '0'),
    }));
}

export function PlanInstEditModal({
  pageId,
  mode,
  row,
  onClose,
  onClosed,
}: PlanInstEditModalProps): ReactElement {
  const dataSource = useDataSource();
  const dialogs = useDialogs();
  const isEdit = mode === 'edit' && row !== null;

  // ------------------------------------------------------------------
  // 主表單（:928-1009；新增預設＝TRAINING_PLAN_INST_DEFAULTS，修改＝row legacy 鍵）。
  // ------------------------------------------------------------------
  const [annualId, setAnnualId] = useState(
    isEdit ? String(row?.['annualIdName'] ?? '') : (TRAINING_PLAN_INST_DEFAULTS['annualId'] ?? ''),
  );
  const [organizationId, setOrganizationId] = useState(
    isEdit
      ? String(row?.['organizationId'] ?? '')
      : (TRAINING_PLAN_INST_DEFAULTS['organizationId'] ?? ''),
  );
  const [jobTypeId, setJobTypeId] = useState(
    isEdit ? String(row?.['jobTypeId'] ?? '') : (TRAINING_PLAN_INST_DEFAULTS['jobTypeId'] ?? ''),
  );
  const [planTargetId, setPlanTargetId] = useState(
    isEdit
      ? String(row?.['planTargetId'] ?? '')
      : (TRAINING_PLAN_INST_DEFAULTS['planTargetId'] ?? ''),
  );
  const [phaseTargetId, setPhaseTargetId] = useState(
    isEdit
      ? String(row?.['phaseTargetId'] ?? '')
      : (TRAINING_PLAN_INST_DEFAULTS['phaseTargetId'] ?? ''),
  );
  const [studentId, setStudentId] = useState(
    isEdit ? String(row?.['studentId'] ?? '') : (TRAINING_PLAN_INST_DEFAULTS['studentId'] ?? '-1'),
  );
  const [mentorId, setMentorId] = useState(
    isEdit ? String(row?.['mentorId'] ?? '') : (TRAINING_PLAN_INST_DEFAULTS['mentorId'] ?? ''),
  );
  const [searchStudentCode, setSearchStudentCode] = useState('');
  const [searchMentorNo, setSearchMentorNo] = useState('');
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
  const [busy, setBusy] = useState(false);

  // ------------------------------------------------------------------
  // 期程列（getPhaseInstListAjax 鏡像；修改＝row.planInstList；新增＝固定 2 列 leaf 骨架）。
  // ------------------------------------------------------------------
  const [phaseRows, setPhaseRows] = useState<PhaseRowState[]>(() => {
    if (isEdit) {
      return toPhaseStates(row?.['planInstList']);
    }
    return [
      {
        id: 'new-1', phaseType: 'SubPhase', phaseTargetId: '-1', phaseTargetIdName: '', refId: '',
        startDateStr: '', endDateStr: '', mentorId1: '', mentorId2: '', clinicalId: '',
        clinicalId2: '', clinicalId3: '', wardId: '', isActive: '1', mentorAmount: '1', clinicalAmount: '1',
      },
      {
        id: 'new-2', phaseType: 'SubPhase', phaseTargetId: '-1', phaseTargetIdName: '', refId: '',
        startDateStr: '', endDateStr: '', mentorId1: '', mentorId2: '', clinicalId: '',
        clinicalId2: '', clinicalId3: '', wardId: '', isActive: '1', mentorAmount: '1', clinicalAmount: '1',
      },
    ];
  });
  const [roles, setRoles] = useState<Row[]>(() => {
    const list = row?.['planInstRoles'];
    return Array.isArray(list) ? (list as Row[]) : [];
  });

  const title = isEdit ? '修改訓練期程' : '新增訓練期程'; // :812/:817（thisFunctionName＝訓練期程）
  // modify → .noEdit 全 disabled（:818-822）。
  const noEditDisabled = isEdit;

  /** 更新某一期程列。 */
  const patchPhase = (id: string, patch: Partial<PhaseRowState>) => {
    setPhaseRows((current) => current.map((entry) => (entry.id === id ? { ...entry, ...patch } : entry)));
  };

  /** 訓練階段 select 變更（leaf 未配置）：重覆檢查＋同步 phaseType/名稱（:549-627）。 */
  const changePhaseTarget = (entry: PhaseRowState, nextId: string) => {
    if (nextId === '-1') {
      patchPhase(entry.id, { phaseTargetId: '-1', phaseTargetIdName: '', refId: '' });
      return;
    }
    const duplicated = phaseRows.some(
      (other) => other.id !== entry.id && other.phaseTargetId === nextId,
    );
    if (duplicated) {
      const picked = TRAINING_SUB_PHASE_TARGETS.find((target) => target.id === nextId);
      void dialogs.alert(`訓練階段 [${picked?.name ?? ''} ] 重覆,請重新選擇!`); // :676
      return; // legacy 回 -1：不寫入。
    }
    const picked = TRAINING_SUB_PHASE_TARGETS.find((target) => target.id === nextId);
    patchPhase(entry.id, {
      phaseTargetId: nextId,
      phaseTargetIdName: picked?.name ?? '',
      phaseType: picked?.phaseType ?? entry.phaseType,
      refId: '',
    });
  };

  // ------------------------------------------------------------------
  // 存檔（savePlanInst :840-878）
  // ------------------------------------------------------------------
  const saveSuccessText = () =>
    resolveLegacyMessage(pageId, 'success')?.text ?? t('state.saveSuccess');

  const save = () => {
    void (async () => {
      const errors: Record<string, string> = {};
      if (annualId.trim() === '') errors.annualId = REQUIRED_TEXT;
      if (organizationId.trim() === '') errors.organizationId = REQUIRED_TEXT;
      if (jobTypeId.trim() === '') errors.jobTypeId = REQUIRED_TEXT;
      if (planTargetId.trim() === '') errors.planTargetId = REQUIRED_TEXT;
      if (Object.keys(errors).length > 0) {
        setFieldErrors(errors);
        return;
      }
      setFieldErrors({});
      // studentId<0 → showAlertDialog("學生資料錯誤!")（:845；legacy select required 對
      // 哨兵 -1 不攔，先 valid() 後才檢）。
      if (studentId.trim() === '' || studentId === '-1') {
        await dialogs.alert('學生資料錯誤!');
        return;
      }
      const payload: Row = {
        annualId,
        organizationId,
        jobTypeId,
        planTargetId,
        phaseTargetId,
        studentId,
        mentorId,
        // 期程列/角色人員設定存列上（批次 11/13 examGroups／classForms 同款）。
        planInstList: phaseRows.map((entry) => ({ ...entry })),
        planInstRoles: roles.map((entry) => ({ ...entry })),
      };
      setBusy(true);
      try {
        if (isEdit) {
          await dialogs.processing.wrap(
            dataSource.update(pageId, String(row?.id ?? ''), payload),
          );
        } else {
          await dialogs.processing.wrap(dataSource.create(pageId, payload));
        }
        onClose();
        onClosed();
        await dialogs.info(saveSuccessText());
      } catch (cause: unknown) {
        onClosed();
        await dialogs.alert(cause instanceof MockDataError ? cause.message : t('error.generic'));
      } finally {
        setBusy(false);
      }
    })();
  };

  // ------------------------------------------------------------------
  // 刪除（deletePlanInst :880-901）
  // ------------------------------------------------------------------
  const remove = () => {
    void (async () => {
      const confirmed = await dialogs.confirm('刪除資料後無法復原，是否確定要刪除?'); // :881
      if (!confirmed) {
        return;
      }
      setBusy(true);
      try {
        await dialogs.processing.wrap(
          dataSource.remove(pageId, String(row?.id ?? '')),
        );
        onClose();
        onClosed();
        await dialogs.info(saveSuccessText());
      } catch (cause: unknown) {
        onClosed();
        await dialogs.alert(cause instanceof MockDataError ? cause.message : t('error.generic'));
      } finally {
        setBusy(false);
      }
    })();
  };

  const studentOptions = TRAINING_STUDENT_OPTIONS.filter((option) =>
    searchStudentCode.trim() === '' ? true : option.label.includes(searchStudentCode.trim()),
  );
  const mentorOptions = TRAINING_MENTOR_OPTIONS.filter((option) =>
    searchMentorNo.trim() === '' ? true : option.label.includes(searchMentorNo.trim()),
  );
  const refTypesOf = (phaseType: string) =>
    phaseType === 'RefElective1' ||
    phaseType === 'RefElective2' ||
    phaseType === 'RefElective3' ||
    phaseType === 'RefElective4' ||
    phaseType === 'RefElective5' ||
    phaseType === 'community' ||
    phaseType === 'communityIn';

  return (
    <ModalFrame
      uiId={`${pageId}-plan-inst-dialog`}
      open
      title={title}
      size="lg"
      onClose={onClose}
      footer={
        <>
          <Button uiId={`${pageId}-plan-inst-dialog-cancel`} variant="default" size="sm" type="button" onClick={onClose}>
            關閉
          </Button>
          {/* :1032 btnDelete（planInstList-DELETE；新增時隱藏 :801-805）。 */}
          {isEdit ? (
            <Button
              uiId={`${pageId}-plan-inst-dialog-delete`}
              variant="danger"
              size="sm"
              type="button"
              disabled={busy}
              dataEffect={`remove:${pageId}`}
              onClick={remove}
            >
              刪除
            </Button>
          ) : null}
          {/* :1035 btnSave（planInstList-UPDATE）。 */}
          <Button
            uiId={`${pageId}-plan-inst-dialog-save`}
            variant="primary"
            size="sm"
            type="button"
            disabled={busy}
            dataEffect={isEdit ? `update:${pageId}` : `create:${pageId}`}
            onClick={save}
          >
            存檔
          </Button>
        </>
      }
    >
      <div className="space-y-3">
        {/* *學年度（:937-944；noEdit＝modify 鎖定）。 */}
        <div className="flex items-center gap-2">
          <label className="w-24 shrink-0 text-right text-sm">
            <span className="text-red-600">*</span>學年度：
          </label>
          <div className="w-48">
            <Select
              uiId={`${pageId}-plan-inst-dialog-annual-id`}
              value={annualId}
              disabled={noEditDisabled}
              onChange={(next) => setAnnualId(next)}
              options={COURSE_CLAZZ_ANNUAL_OPTIONS}
            />
            {fieldErrors.annualId !== undefined ? (
              <p className="text-xs text-red-600">{fieldErrors.annualId}</p>
            ) : null}
          </div>
        </div>
        {/* *醫院（:945-952）。 */}
        <div className="flex items-center gap-2">
          <label className="w-24 shrink-0 text-right text-sm">
            <span className="text-red-600">*</span>醫院：
          </label>
          <div className="w-48">
            <Select
              uiId={`${pageId}-plan-inst-dialog-organization-id`}
              value={organizationId}
              disabled={noEditDisabled}
              onChange={(next) => setOrganizationId(next)}
              options={ACCOUNT_ORGANIZATION_OPTIONS}
            />
            {fieldErrors.organizationId !== undefined ? (
              <p className="text-xs text-red-600">{fieldErrors.organizationId}</p>
            ) : null}
          </div>
        </div>
        {/* *訓練類別（:953-958；spring code job.type）。 */}
        <div className="flex items-center gap-2">
          <label className="w-24 shrink-0 text-right text-sm">
            <span className="text-red-600">*</span>訓練類別：
          </label>
          <div className="w-48">
            <Select
              uiId={`${pageId}-plan-inst-dialog-job-type-id`}
              value={jobTypeId}
              disabled={noEditDisabled}
              onChange={(next) => setJobTypeId(next)}
              options={TRAINING_JOB_TYPE_OPTIONS.map((option) => ({ value: option.value, label: option.label }))}
            />
            {fieldErrors.jobTypeId !== undefined ? (
              <p className="text-xs text-red-600">{fieldErrors.jobTypeId}</p>
            ) : null}
          </div>
        </div>
        {/* *訓練計畫（:959-964；spring code plan.target）。 */}
        <div className="flex items-center gap-2">
          <label className="w-24 shrink-0 text-right text-sm">
            <span className="text-red-600">*</span>訓練計畫：
          </label>
          <div className="w-64">
            <Select
              uiId={`${pageId}-plan-inst-dialog-plan-target-id`}
              value={planTargetId}
              disabled={noEditDisabled}
              onChange={(next) => setPlanTargetId(next)}
              options={COURSE_CLAZZ_PLAN_TARGET_OPTIONS}
            />
            {fieldErrors.planTargetId !== undefined ? (
              <p className="text-xs text-red-600">{fieldErrors.planTargetId}</p>
            ) : null}
          </div>
        </div>
        {/* 組別（:965-970）。 */}
        <div className="flex items-center gap-2">
          <label className="w-24 shrink-0 text-right text-sm">組別：</label>
          <div className="w-48">
            <Select
              uiId={`${pageId}-plan-inst-dialog-phase-target-id`}
              value={phaseTargetId}
              disabled={noEditDisabled}
              onChange={(next) => setPhaseTargetId(next)}
              options={[{ value: '-1', label: '' }, ...TRAINING_PHASE_TARGET_OPTIONS]}
            />
          </div>
        </div>
        {/* *學員（:968-983；searchStudentCode＋studentId；modify 鎖定）。 */}
        <div className="flex items-center gap-2">
          <label className="w-24 shrink-0 text-right text-sm">
            <span className="text-red-600">*</span>學員：
          </label>
          <div className="w-40">
            <TextInput
              uiId={`${pageId}-plan-inst-dialog-search-student-code`}
              value={searchStudentCode}
              disabled={noEditDisabled}
              placeholder="(請輸入學員姓名或學員編號)"
              onChange={(next) => setSearchStudentCode(next)}
            />
          </div>
          <div className="w-48">
            <Select
              uiId={`${pageId}-plan-inst-dialog-student-id`}
              value={studentId}
              disabled={noEditDisabled}
              onChange={(next) => setStudentId(next)}
              options={[{ value: '-1', label: '' }, ...studentOptions]}
            />
            {fieldErrors.studentId !== undefined ? (
              <p className="text-xs text-red-600">{fieldErrors.studentId}</p>
            ) : null}
          </div>
        </div>
        {/* 計畫導師（:984-1000；searchMentorDept＋searchMentorNo＋mentorId＋resetMentorIdBtn）。 */}
        <div className="flex items-center gap-2">
          <label className="w-24 shrink-0 text-right text-sm">計畫導師：</label>
          <div className="w-40">
            <Select
              uiId={`${pageId}-plan-inst-dialog-search-mentor-dept`}
              value=""
              onChange={() => undefined}
              options={[{ value: '', label: '' }, ...TRAINING_MENTOR_DEPT_OPTIONS]}
            />
          </div>
          <div className="w-40">
            <TextInput
              uiId={`${pageId}-plan-inst-dialog-search-mentor-no`}
              value={searchMentorNo}
              placeholder="(請輸入導師姓名或員工編號)"
              onChange={(next) => setSearchMentorNo(next)}
            />
          </div>
          <div className="w-48">
            <Select
              uiId={`${pageId}-plan-inst-dialog-mentor-id`}
              value={mentorId}
              onChange={(next) => setMentorId(next)}
              options={[{ value: '-1', label: '' }, ...mentorOptions]}
            />
          </div>
          <Button
            uiId={`${pageId}-plan-inst-dialog-reset-mentor-id`}
            variant="default"
            size="sm"
            type="button"
            onClick={() => setMentorId('-1')}
          >
            清除
          </Button>
        </div>
        {/* 註記（:1001-1005；hidden group——legacy class="form-group hidden"，照實不顯示輸入框）。 */}
        {/* :1010-1013 alert-danger 逐字。 */}
        <p data-ui-id={`${pageId}-plan-inst-dialog-ugy-alert`} className="bg-red-100 px-3 py-2 text-sm text-red-700">
          西醫UGY安排臨床教師時：臨床教師第1順位請指定住院醫師，第2順位請指定主治醫生
        </p>

        {/* 期程表（:1014-1031 表頭；欄渲染 :284-455；非 leaf 列整列隱藏 :759-769）。 */}
        <div className="overflow-x-auto">
          <table className="w-full border-collapse text-sm" data-ui-id={`${pageId}-plan-inst-dialog-phase-inst-table`}>
            <thead>
              <tr className="border-b border-border-strong">
                <th className="p-2 text-center">
                  <span className="text-red-600">*</span>訓練期間
                </th>
                <th className="p-2 text-center">
                  <span className="text-red-600">*</span>訓練階段
                </th>
                <th className="p-2 text-center">階段導師</th>
                <th className="p-2 text-center">臨床教師</th>
                <th className="p-2 text-center">訓練地點</th>
                <th className="p-2 text-center">暫停訓練</th>
              </tr>
            </thead>
            <tbody>
              {phaseRows
                .filter((entry) => TRAINING_LEAF_PHASE_TYPES.includes(entry.phaseType))
                .map((entry) => {
                  const configured = entry.phaseTargetId !== '-1' && entry.phaseTargetId !== '';
                  const refOptions =
                    refTypesOf(entry.phaseType) === true
                      ? (TRAINING_REF_POOL[entry.phaseType] ?? [])
                      : [];
                  const mentorCount = Number(entry.mentorAmount || '0');
                  const clinicalCount = Number(entry.clinicalAmount || '0');
                  return (
                    <tr key={entry.id} className="border-b border-border" data-ui-id={`${pageId}-plan-inst-dialog-phase-inst-row-${entry.id}`}>
                      {/* col0：訓練期間（startDateStr＋endDateStr 文字輸入；checkDate）。 */}
                      <td className="p-2">
                        <div className="flex items-center gap-1">
                          <TextInput
                            uiId={`${pageId}-plan-inst-dialog-start-date-${entry.id}`}
                            value={entry.startDateStr}
                            onChange={(next) => patchPhase(entry.id, { startDateStr: next })}
                          />
                          <TextInput
                            uiId={`${pageId}-plan-inst-dialog-end-date-${entry.id}`}
                            value={entry.endDateStr}
                            onChange={(next) => patchPhase(entry.id, { endDateStr: next })}
                          />
                        </div>
                      </td>
                      {/* col1：訓練階段（已配置 disabled＋refId select；未配置 subPhaseTargetList）。 */}
                      <td className="p-2">
                        <Select
                          uiId={`${pageId}-plan-inst-dialog-phase-target-${entry.id}`}
                          value={entry.phaseTargetId}
                          disabled={configured}
                          onChange={(next) => changePhaseTarget(entry, next)}
                          options={
                            configured
                              ? [{ value: entry.phaseTargetId, label: entry.phaseTargetIdName }]
                              : [{ value: '-1', label: '' }, ...TRAINING_SUB_PHASE_TARGETS.map((target) => ({ value: target.id, label: target.name }))]
                          }
                        />
                        {refOptions.length > 0 ? (
                          <div className="mt-2">
                            <Select
                              uiId={`${pageId}-plan-inst-dialog-ref-id-${entry.id}`}
                              value={entry.refId}
                              onChange={(next) => patchPhase(entry.id, { refId: next })}
                              options={[{ value: '', label: '請選擇' }, ...refOptions]}
                            />
                          </div>
                        ) : null}
                      </td>
                      {/* col2：階段導師（mentorAmount>0→mentorId1；>1→+mentorId2）。 */}
                      <td className="p-2">
                        <div className="space-y-1">
                          {mentorCount > 0 ? (
                            <div className="flex items-center gap-1">
                              <div className="w-24">
                                <Select
                                  uiId={`${pageId}-plan-inst-dialog-mentor-dept-${entry.id}-1`}
                                  value=""
                                  onChange={() => undefined}
                                  options={[{ value: '', label: '' }, ...TRAINING_MENTOR_DEPT_OPTIONS]}
                                />
                              </div>
                              <div className="w-32">
                                <Select
                                  uiId={`${pageId}-plan-inst-dialog-mentor-id1-${entry.id}`}
                                  value={entry.mentorId1}
                                  onChange={(next) => patchPhase(entry.id, { mentorId1: next })}
                                  options={[{ value: '-1', label: '' }, ...TRAINING_MENTOR_OPTIONS]}
                                />
                              </div>
                            </div>
                          ) : null}
                          {mentorCount > 1 ? (
                            <div className="flex items-center gap-1">
                              <div className="w-24">
                                <Select
                                  uiId={`${pageId}-plan-inst-dialog-mentor-dept-${entry.id}-2`}
                                  value=""
                                  onChange={() => undefined}
                                  options={[{ value: '', label: '' }, ...TRAINING_MENTOR_DEPT_OPTIONS]}
                                />
                              </div>
                              <div className="w-32">
                                <Select
                                  uiId={`${pageId}-plan-inst-dialog-mentor-id2-${entry.id}`}
                                  value={entry.mentorId2}
                                  onChange={(next) => patchPhase(entry.id, { mentorId2: next })}
                                  options={[{ value: '-1', label: '' }, ...TRAINING_MENTOR_OPTIONS]}
                                />
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </td>
                      {/* col3：臨床教師（clinicalAmount>0/1/2→clinicalId/clinicalId2/clinicalId3）。 */}
                      <td className="p-2">
                        <div className="space-y-1">
                          {clinicalCount > 0 ? (
                            <Select
                              uiId={`${pageId}-plan-inst-dialog-clinical-id-${entry.id}`}
                              value={entry.clinicalId}
                              onChange={(next) => patchPhase(entry.id, { clinicalId: next })}
                              options={[{ value: '-1', label: '' }, ...TRAINING_CLINICAL_OPTIONS]}
                            />
                          ) : null}
                          {clinicalCount > 1 ? (
                            <Select
                              uiId={`${pageId}-plan-inst-dialog-clinical-id2-${entry.id}`}
                              value={entry.clinicalId2}
                              onChange={(next) => patchPhase(entry.id, { clinicalId2: next })}
                              options={[{ value: '-1', label: '' }, ...TRAINING_CLINICAL_OPTIONS]}
                            />
                          ) : null}
                          {clinicalCount > 2 ? (
                            <Select
                              uiId={`${pageId}-plan-inst-dialog-clinical-id3-${entry.id}`}
                              value={entry.clinicalId3}
                              onChange={(next) => patchPhase(entry.id, { clinicalId3: next })}
                              options={[{ value: '-1', label: '' }, ...TRAINING_CLINICAL_OPTIONS]}
                            />
                          ) : null}
                        </div>
                      </td>
                      {/* col4：訓練地點（leaf 才有；preOption NA）。 */}
                      <td className="p-2">
                        <Select
                          uiId={`${pageId}-plan-inst-dialog-ward-id-${entry.id}`}
                          value={entry.wardId}
                          onChange={(next) => patchPhase(entry.id, { wardId: next })}
                          options={[{ value: '-1', label: 'NA' }, ...TRAINING_WARD_OPTIONS]}
                        />
                      </td>
                      {/* col5：暫停訓練 isActive checkbox（isActive==0→checked，:411-424）。 */}
                      <td className="p-2 text-center">
                        <Checkbox
                          uiId={`${pageId}-plan-inst-dialog-is-active-${entry.id}`}
                          checked={entry.isActive === '0'}
                          onChange={(next) => patchPhase(entry.id, { isActive: next ? '0' : '1' })}
                          label="暫停訓練"
                        />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

        {/* 角色人員設定（:699-757）。 */}
        <div data-ui-id={`${pageId}-plan-inst-dialog-role-list`}>
          {roles.length > 0 ? (
            <>
              <p className="text-sm font-semibold text-sky-700">[角色人員設定]</p>
              <div className="space-y-2">
                {roles.map((roleEntry, index) => {
                  const roleId = String(roleEntry['phaseTargetRoleId'] ?? `role-${index + 1}`);
                  const flowRole = String(roleEntry['flowRole'] ?? 'Any');
                  const currentAccountId = String(roleEntry['accountId'] ?? '');
                  const pool =
                    flowRole === 'Student'
                      ? TRAINING_STUDENT_OPTIONS
                      : flowRole === 'Mentor'
                        ? TRAINING_MENTOR_OPTIONS
                        : flowRole === 'Clinical'
                          ? TRAINING_CLINICAL_OPTIONS
                          : [...TRAINING_MENTOR_OPTIONS, ...TRAINING_CLINICAL_OPTIONS, ...TRAINING_STUDENT_OPTIONS];
                  return (
                    <div key={roleId} className="flex items-center gap-2">
                      <label className="w-40 shrink-0 text-right text-sm">
                        {String(roleEntry['roleName'] ?? '')}：
                      </label>
                      <div className="w-40">
                        <TextInput
                          uiId={`${pageId}-plan-inst-dialog-role-keyword-${roleId}`}
                          value=""
                          placeholder="(請輸入姓名或員工編號)"
                          onChange={() => undefined}
                        />
                      </div>
                      <div className="w-48">
                        <Select
                          uiId={`${pageId}-plan-inst-dialog-role-account-${roleId}`}
                          value={currentAccountId}
                          onChange={(next) => {
                            const picked = pool.find((option) => option.value === next);
                            setRoles((currentRoles) =>
                              currentRoles.map((entry) =>
                                String(entry['phaseTargetRoleId'] ?? '') === roleId
                                  ? { ...entry, accountId: next, accountName: picked?.label ?? '' }
                                  : entry,
                              ),
                            );
                          }}
                          options={[{ value: '-1', label: '' }, ...pool]}
                        />
                      </div>
                      <Button
                        uiId={`${pageId}-plan-inst-dialog-role-reset-${roleId}`}
                        variant="default"
                        size="sm"
                        type="button"
                        onClick={() => {
                          setRoles((currentRoles) =>
                            currentRoles.map((entry) =>
                              String(entry['phaseTargetRoleId'] ?? '') === roleId
                                ? { ...entry, accountId: '', accountName: '' }
                                : entry,
                            ),
                          );
                        }}
                      >
                        清除
                      </Button>
                    </div>
                  );
                })}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </ModalFrame>
  );
}
